import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Avatar, Spin, Pagination } from "antd";
import {
  Container,
  Content,
  TicketCard,
  TicketList,
  TicketView,
  TicketViewHeader,
  CardCount,
} from "./styles";
import Status from "../../../components/status";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdPerson } from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { format, isToday } from "date-fns";
import { Message } from "../../../GlobalStyles";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";

const ChamadosAdmin = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [tickets, setTickets] = useState([]);
  const [page, setPage] = useState(0);
  const [ticketsTotal, setTicketsTotal] = useState(0);

  useEffect(() => {
    loadChats(page);
  }, [page]);

  async function loadChats(page) {
    setIsLoading(true);
    await api
      .get(`/admin/tickets?page=${page}`)
      .then((response) => {
        setTickets(response.data.tickets);
        setTicketsTotal(response.data.ticketsTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.warn(
            "Ocorreu um erro, verifique sua conexão e tente novamente",
          );
        }
      });
    setIsLoading(false);
  }

  if (selectedTicket) {
    return (
      <>
        <Content
          style={{
            maxWidth: 600,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              shape="round"
              onClick={() => {
                setSelectedTicket(null);
              }}
              style={{ marginBottom: 15 }}
            >
              Voltar
            </Button>
          </div>
          <TicketView>
            <TicketViewHeader>
              <div style={{ width: "50%" }}>
                <Avatar
                  src={selectedTicket.attendant?.photo_url || null}
                  icon={<MdPerson />}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    margin: "0 15px",
                    flex: 1,
                  }}
                >
                  <h2>{selectedTicket.attendant?.name}</h2>
                  <p>{selectedTicket.protocol_id}</p>
                </div>
              </div>
              {!!selectedTicket.order_id && (
                <div
                  style={{
                    marginBottom: 15,
                  }}
                >
                  <p
                    style={{
                      margin: "0 10px",
                    }}
                  >
                    OS relacionada:
                  </p>
                  <Button
                    type="primary"
                    style={{
                      borderRadius: 50,
                      height: 25,
                    }}
                    onClick={() => {
                      navigate(`/${user.type}/os/${selectedTicket.order_id}`);
                    }}
                  >
                    {selectedTicket.order_id}
                  </Button>
                </div>
              )}
              <Status
                style={{ marginBottom: 15, marginLeft: 16 }}
                isAttendant={true}
                status={selectedTicket.status}
              />
            </TicketViewHeader>

            <div
              className="chat-window-body"
              style={{
                display: "flex",
                padding: 16,
                height: "60vh",
                flexDirection: "column-reverse",
              }}
            >
              {selectedTicket.messages.map((msg, index) => {
                const prevMsg = selectedTicket.messages[index + 1] || null;
                const backMsg =
                  index > 0 ? selectedTicket.messages[index - 1] : null;

                // 1. Criamos chaves únicas para o minuto (Ex: "2025-12-17 16:30")
                // Isso ignora os segundos na comparação.
                const currentMinuteKey = format(
                  new Date(msg.created_at),
                  "yyyyMMddHHmm",
                );
                const prevMinuteKey = prevMsg
                  ? format(new Date(prevMsg.created_at), "yyyyMMddHHmm")
                  : null;
                const backMinuteKey = backMsg
                  ? format(new Date(backMsg.created_at), "yyyyMMddHHmm")
                  : null;

                // 2. Condição de Agrupamento: Mesmo Remetente E Mesmo Minuto
                const isGrouped =
                  prevMsg &&
                  String(prevMsg.send_id) === String(msg.send_id) &&
                  prevMinuteKey === currentMinuteKey;

                const isGroupedBack =
                  backMsg &&
                  String(backMsg.send_id) === String(msg.send_id) &&
                  backMinuteKey === currentMinuteKey;

                const messageClasses = [
                  "message",
                  msg.send_id === selectedTicket.attendant_id
                    ? "sent"
                    : "received",
                  isGrouped || isGroupedBack ? "grouped" : "first-in-group",
                ].join(" ");

                return (
                  <div key={msg.id || index} className={messageClasses}>
                    <span
                      className="time-label"
                      style={{
                        fontSize: "0.8rem",
                        margin: "5px 0",
                        fontWeight: 600,
                      }}
                    >
                      {msg.send_id === selectedTicket.attendant_id
                        ? "Atendente: "
                        : selectedTicket.user_id
                          ? "Franqueado: "
                          : "Técnico: "}
                    </span>
                    <div
                      className={`message-content ${
                        isGrouped || isGroupedBack ? "no-tip" : ""
                      }`}
                    >
                      <p>{msg.content}</p>
                    </div>
                    {!isGroupedBack && (
                      <div
                        className="message-header"
                        style={{
                          display: "flex",
                          justifyContent:
                            msg.send_id === user.id ? "flex-end" : "flex-start",
                          gap: "8px",
                        }}
                      >
                        <span
                          className="time-label"
                          style={{
                            fontSize: "0.7rem",
                            margin: "5px 0",
                            color: "#888",
                          }}
                        >
                          {format(
                            new Date(msg.created_at),
                            isToday(new Date(msg.created_at))
                              ? "HH:mm"
                              : "dd/MM/yyyy HH:mm",
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </TicketView>
        </Content>
      </>
    );
  }

  function renderTicket(ticket, messageView) {
    return (
      <TicketCard
        key={ticket.id}
        onClick={() => {
          setSelectedTicket(ticket);
          const element = chatContainerRef.current;
          if (element) {
            element.scrollTop = element.scrollHeight;
          }
        }}
      >
        <Card>
          <div className="card-header">
            <span
              style={{
                flex: 1,
              }}
            >
              {ticket.protocol_id}
            </span>
            <div
              style={{
                display: "flex",
              }}
            >
              {!!ticket.order_id && (
                <Button
                  type="primary"
                  style={{
                    borderRadius: 50,
                    height: 20,
                    margin: "0 15px",
                  }}
                  onClick={() => {
                    navigate(`/${user.type}/os/${ticket.order_id}`);
                  }}
                >
                  {ticket.order_id}
                </Button>
              )}
              <Status isAttendant={true} isMini={true} status={ticket.status} />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Avatar
              src={
                ticket.user?.photo_url || ticket.collaborator?.photo_url || null
              }
              icon={<MdPerson />}
            />
            <strong
              className="ant-card-meta-title"
              style={{
                marginLeft: 15,
              }}
            >
              {ticket.user?.name || ticket.collaborator?.name}
            </strong>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Card.Meta
              avatar={
                <Avatar
                  src={ticket.attendant?.photo_url || null}
                  icon={<MdPerson />}
                />
              }
              style={{ flex: 1 }}
              title={ticket.attendant?.name || "Aguardando Atendente"}
              description={messageView}
            />
          </div>
          {ticket.status == "finalizado" && (
            <div className="ticket-info">
              <span>
                Finalizado em{" "}
                {format(new Date(ticket.updated_at), "dd/MM/yyyy HH:mm")}{" "}
              </span>
            </div>
          )}
          {ticket.status != "finalizado" && (
            <div className="ticket-info">
              <span>
                Aberto em{" "}
                {format(new Date(ticket.created_at), "dd/MM/yyyy HH:mm")}{" "}
              </span>
            </div>
          )}
        </Card>
      </TicketCard>
    );
  }

  return (
    <Container>
      <h1>Todos Chamados</h1>
      <CardCount>
        <p>Total</p>
        <CountUp separator="." duration={1} end={ticketsTotal} />
      </CardCount>
      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Content>
            {!ticketsTotal && (
              <Message
                style={{
                  width: "70%",
                  alignSelf: "center",
                  marginTop: 60,
                }}
              >
                Nenhum chamado foi encontrado
              </Message>
            )}
            <TicketList
              style={{
                margin: "15px 0",
              }}
            >
              {tickets.map((ticket) => {
                const message = ticket.messages[0];
                const messageView =
                  message.send_id == user.id
                    ? `Você: ${message.content}`
                    : message.content;
                return renderTicket(ticket, messageView);
              })}
            </TicketList>
          </Content>
        </>
      )}

      <Pagination
        style={{
          margin: "25px 0",
          alignSelf: "center",
        }}
        defaultCurrent={page + 1}
        pageSize={30}
        onChange={(page) => {
          setPage(page - 1);
        }}
        total={ticketsTotal}
      />
    </Container>
  );
};

export default ChamadosAdmin;
